// import React from 'react'
import $ from "jquery";
import slick from "slick-carousel";

export const init = () => {
  $(function () {
    $(".slider-services-22").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 4000,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
            centerMode: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
            centerMode: false,
          },
        },
      ],
    });
  });
};

// export const init1 = () => {
//   $(document).ready(function () {
//     // alert("init1 ===");
//     var $swipeTabsContainer = $(".swipe-tabs"),
//       $swipeTabs = $(".swipe-tab"),
//       $swipeTabsContentContainer = $(".swipe-tabs-container"),
//       currentIndex = 0,
//       activeTabClassName = "active-tab";
//     //console.log('swipe tab', $swipeTabs);

//     $swipeTabsContainer.on("init", function (event, slick) {
//       $swipeTabsContentContainer.removeClass("invisible");
//       $swipeTabsContainer.removeClass("invisible");

//       currentIndex = slick.getCurrent();
//       $swipeTabs.removeClass(activeTabClassName);
//       $(".swipe-tab[data-slick-index=" + currentIndex + "]").addClass(
//         activeTabClassName
//       );
//     });

//     $swipeTabsContainer.slick({
//       //slidesToShow: 3.25,
//       slidesToShow: 2,
//       slidesToScroll: 1,
//       arrows: false,
//       autoplay: true,
//       infinite: false,
//       autoplaySpeed: 4000,
//       swipeToSlide: true,
//       touchThreshold: 10,
//     });

//     $swipeTabsContentContainer.slick({
//       asNavFor: $swipeTabsContainer,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: false,
//       autoplay: false,
//       infinite: false,
//       swipeToSlide: true,
//       draggable: false,
//       touchThreshold: 10,
//     });

//     $swipeTabs.on("click", function (event) {
//       // gets index of clicked tab
//       currentIndex = $(this).data("slick-index");
//       $swipeTabs.removeClass(activeTabClassName);
//       $(".swipe-tab[data-slick-index=" + currentIndex + "]").addClass(
//         activeTabClassName
//       );
//       $swipeTabsContainer.slick("slickGoTo", currentIndex);
//       $swipeTabsContentContainer.slick("slickGoTo", currentIndex);
//     });

//     //initializes slick navigation tabs swipe handler
//     $swipeTabsContentContainer.on("swipe", function (event, slick, direction) {
//       currentIndex = $(this).slick("slickCurrentSlide");
//       $swipeTabs.removeClass(activeTabClassName);
//       $(".swipe-tab[data-slick-index=" + currentIndex + "]").addClass(
//         activeTabClassName
//       );
//     });
//   });
// };

export const init2 = () => {
  $(function () {
    $(".slider-services").slick({
      dots: false,
      appendDots: ".slider-dots",
      arrows: false,
      infinite: true,
      slidesToScroll: 3,
      slidesToShow: 4,
      autoplay: true,
      accessibility: true,
      variableWidth: false,
      focusOnSelect: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
            centerMode: true,
          },
        },
      ],
    });
  });
};

export const init3 = () => {
  $(function () {
    $(".slider-services-2").slick({
      dots: false,
      appendDots: ".slider-dots",
      arrows: false,
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 4,
      autoplay: true,
      autoplaySpeed: 4000,
      accessibility: true,
      variableWidth: false,
      focusOnSelect: false,
      centerMode: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
            centerMode: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
            centerMode: false,
          },
        },
      ],
    });
  });
};

export const init4 = () => {
  $(function () {
    $(".slider-services-3").slick({
      slidesToShow: 6,
      infinite: true,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 3,
            centerMode: true,
          },
        },
      ],
    });
  });
};

//export const init5 = () => {};

export const init6 = () => {
  var navss = $("div.nav3");
  var liness = $("<div />").addClass("liness");

  liness.appendTo(navss);

  var actived = navss.find(".actived");
  var poss = 0;
  var wids = 0;

  if (actived.length) {
    poss = actived.position().left;
    wids = actived.width();
    liness.css({
      left: poss,
      width: wids,
    });
  }

  navss.find("ul li button").click(function (e) {
    e.preventDefault();
    if (!$(this).parent().hasClass("actived") && !navss.hasClass("animate")) {
      navss.addClass("animate");

      var _this = $(this);

      navss.find("ul li").removeClass("actived");

      var position = _this.parent().position();
      var width = _this.parent().width();

      if (position.left >= poss) {
        liness.animate(
          {
            width: position.left - poss + width,
          },
          300,
          function () {
            liness.animate(
              {
                width: width,
                left: position.left,
              },
              150,
              function () {
                navss.removeClass("animate");
              }
            );
            _this.parent().addClass("actived");
          }
        );
      } else {
        liness.animate(
          {
            left: position.left,
            width: poss - position.left + wids,
          },
          300,
          function () {
            liness.animate(
              {
                width: width,
              },
              150,
              function () {
                navss.removeClass("animate");
              }
            );
            _this.parent().addClass("actived");
          }
        );
      }

      poss = position.left;
      wids = width;
    }
  });
};

export const init7 = () => {
  $(".video-thumb").click(function () {
    $(".video-thumb > .actives").removeClass("active");
    $(this).children(".actives").addClass("active");
  });

  $(".actives").click(function () {
    $(".video-iframe iframe").attr(
      "src",
      $(this).children("iframe").attr("src").replace("iframe")
    );
  });
};

export const resource_center = () => {
  var nav = $("div.nav2");
  var line = $("<div />").addClass("line");

  line.appendTo(nav);

  var active = nav.find(".active");
  var pos = 0;
  var wid = 0;

  if (active.length) {
    pos = active.position().left;
    wid = active.width();
    line.css({
      left: pos,
      width: wid,
    });
  }

  nav.find("ul li button").click(function (e) {
    e.preventDefault();
    if (!$(this).parent().hasClass("active") && !nav.hasClass("animate")) {
      nav.addClass("animate");

      var _this = $(this);

      nav.find("ul li").removeClass("active");

      var position = _this.parent().position();
      var width = _this.parent().width();

      if (position.left >= pos) {
        line.animate(
          {
            width: position.left - pos + width,
          },
          300,
          function () {
            line.animate(
              {
                width: width,
                left: position.left,
              },
              150,
              function () {
                nav.removeClass("animate");
              }
            );
            _this.parent().addClass("active");
          }
        );
      } else {
        line.animate(
          {
            left: position.left,
            width: pos - position.left + wid,
          },
          300,
          function () {
            line.animate(
              {
                width: width,
              },
              150,
              function () {
                nav.removeClass("animate");
              }
            );
            _this.parent().addClass("active");
          }
        );
      }

      pos = position.left;
      wid = width;
    }
  });
};

export const init8 = () => {
  $(function () {
    $(".slider-services-23").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      autoplay: false,
      autoplaySpeed: 4000,
      centerMode: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
            centerMode: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2,
            centerMode: false,
          },
        },
      ],
    });
  });
};
export const init9 = () => {
  $(".video-thumb").click(function () {
    $(".video-thumb > .actives").removeClass("active");
    $(this).children(".actives").addClass("active");
  });

  $(".actives").click(function () {
    $(".video-iframe iframe").attr(
      "src",
      $(this).children("iframe").attr("src").replace("iframe")
    );
  });
};
export const init10 = () => {
  document.addEventListener("DOMContentLoaded", function () {
    $(window).scroll(startCounter);
    function startCounter() {
      let scrollY =
        (window.pageYOffset || document.documentElement.scrollTop) +
        window.innerHeight;

      let divPos = document.querySelector("#box").offsetTop;

      if (scrollY > divPos) {
        $(window).off("scroll", startCounter);
        $(".count").each(function () {
          var $this = $(this);
          $({
            Counter: 0,
          }).animate(
            {
              Counter: $this.text().replace(/,/g, ""),
            },
            {
              duration: 20000,
              easing: "swing",
              step: function () {
                $this.text(commaSeparateNumber(Math.floor(this.Counter)));
              },
              complete: function () {
                $this.text(commaSeparateNumber(this.Counter));
                //alert('finished');
              },
            }
          );
        });
        function commaSeparateNumber(num) {
          return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      }
    }
  });
};

export const init11 = () => {
  $(".slider-services-23").slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    centerMode: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToScroll: 2,
          slidesToShow: 2,
          centerMode: false,
        },
      },
    ],
  });
};
